/**
 * Extracts a localized string from a Payload CMS localized field.
 * Handles cases where the field might be a string, an object with language keys, or null/undefined.
 * @param localizedField The field value, which can be a string or an object like { en: "...", te: "..." }
 * @param currentLocale The current locale string (e.g., "te-IN")
 * @returns The localized string, or null if not found
 */
export const getLocalizedString = (
  localizedField: string | { [key: string]: string } | null | undefined,
  currentLocale: string,
): string | null => {
  if (!localizedField) {
    return null;
  }

  // If it's already a string, return it directly
  if (typeof localizedField === "string") {
    return localizedField;
  }

  // If it's an object, try to get the value for the current language
  if (typeof localizedField === "object") {
    const langCode = currentLocale.split("-")[0]; // e.g., "te" from "te-IN"

    if (localizedField[langCode]) {
      return localizedField[langCode];
    }

    // Navatelanga Telugu-only mode:
    // Fallback to 'te' when requested language is unavailable.
    if (localizedField.te) {
      return localizedField.te;
    }

    // Keep English fallback commented for future re-enable.
    // if (localizedField.en) {
    //   return localizedField.en;
    // }
  }

  return null;
};

/**
 * Returns category/subcategory name as stored - no locale switching.
 * Use when category names should stay the same regardless of page language.
 */
export const getCategoryNameAsStored = (
  name: string | { [key: string]: string } | null | undefined,
): string => {
  if (!name) return "";
  if (typeof name === "string") return name;
  if (typeof name === "object") {
    // Telugu-first for Navatelanga.
    // return name.en ?? name.te ?? Object.values(name)[0] ?? "";
    return name.te ?? name.en ?? Object.values(name)[0] ?? "";
  }
  return "";
};

